import styled from "styled-components";

import FlexBox from "../FlexBox";
import { Body2, Caption } from "../Headings";
import { DAVYS_GREY } from "../colors";

import AiIcon from "../../../assets/ai-icon-filled.svg";
import { FiChevronRight } from "react-icons/fi";

const PromptIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

const PromptBox = styled(FlexBox)`
  padding: 0.5rem;
  border: 1px solid ${DAVYS_GREY[400]};
  border-radius: 0.5rem;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;

  &:hover {
    background-color: ${DAVYS_GREY[200]};
  }
`;

const ChevronIcon = styled(FiChevronRight)`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
`;

const AiChatSuggestivePrompts = ({ onPromptSelect, suggestedPrompts = [] }) => {
  return (
    suggestedPrompts?.length > 0 && (
      <FlexBox column rowGap="0.5rem">
        <Caption
          spacing="8%"
          textTransform="uppercase"
          bold
          color={DAVYS_GREY[700]}
        >
          Suggestive prompts you can ask:
        </Caption>

        {suggestedPrompts.map(prompt => (
          <PromptBox key={prompt} onClick={() => onPromptSelect?.(prompt)}>
            <FlexBox columnGap="0.25rem" align="flex-start">
              <PromptIcon src={AiIcon} alt="" />
              <Body2>{prompt}</Body2>
            </FlexBox>
            <ChevronIcon />
          </PromptBox>
        ))}
      </FlexBox>
    )
  );
};

export default AiChatSuggestivePrompts;
